/* @flow */
import type { Action } from "../action";

// Настройки, приходящие с сервера
export type RemoteTradeSettings = {
  defaultInterval: number,
  isOTC: boolean | number,
  bids: Array<number>,
  currency: string,
  initial: number,
  intervals: Array<number>,
  intervalsDemo: Array<number>,
  minFillup: number,
  rawSymbol: string,
  symbol: string,
  percentBidThreshold?: number,
  percentBids?: Array<number>
};

export type State = RemoteTradeSettings;

function receiveSocketMessage(state, payload) {
  switch (payload.op) {
    case "stockPush":
      // Return previous state if socket doesn't support OTC messages yet
      if (payload.otc === undefined) {
        return state;
      }

      const isOTC = payload.otc;

      // Return previous state if OTC haven't change yet
      if (state.isOTC === isOTC) {
        return state;
      }

      // Return new state on OTC change
      return {
        ...state,
        isOTC
      };
    default:
      return state;
  }
}

// function interceptBids(payload: State) {
//   switch (payload.currency) {
//     case "THB":
//       return {
//         ...payload,
//         percentBids: [1, 2, 3, 4, 5, 10, 15, 25, 50, 100] // проценты
//       };
//     default:
//       return { ...payload, percentBids: null };
//   }
// }

const initialState = {
  defaultInterval: 30,
  isOTC: false,
  bids: [],
  currency: "USD",
  initial: 10000,
  intervals: [],
  intervalsDemo: [],
  minFillup: 250,
  rawSymbol: "$",
  symbol: "$"
};

function settings(state: State = initialState, action: Action): State {
  switch (action.type) {
    case "RECEIVE_TRADE_SETTINGS":
      return action.payload;
    case "RECEIVE_SOCKET_MESSAGE":
      return receiveSocketMessage(state, action.payload);
    default:
      return state;
  }
}

export default settings;



// WEBPACK FOOTER //
// ./src/redux/reducer/remoteTradeSettings.js